import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-create-counterparty-dialog',
  template: `
    <div class="pop-400">
      <header class="dialog-header flex-item">
        <h2>Create New Counterparty</h2>
        <button md-dialog-close class="close-btn" tabindex="-1">
          <i class="material-icons">clear</i>
        </button>
      </header>
      <div class="dialog-content" style="padding: 20px;">
        <p style="margin-bottom: 20px;">Create "<strong>{{ name }}</strong>" as:</p>
        <div style="display: flex; gap: 10px; justify-content: center;">
          <button md-raised-button color="primary" (click)="selectType(true)" style="flex: 1;">
            <i class="material-icons" style="vertical-align: middle; margin-right: 4px;">business</i>
            Organisation
          </button>
          <button md-raised-button color="primary" (click)="selectType(false)" style="flex: 1;">
            <i class="material-icons" style="vertical-align: middle; margin-right: 4px;">person</i>
            Person
          </button>
        </div>
      </div>
      <md-card-actions style="padding: 10px 20px;">
        <button md-button (click)="cancel()">Cancel</button>
      </md-card-actions>
    </div>
  `,
  styles: [`
    .pop-400 {
      min-width: 400px;
    }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid #e0e0e0;
    }
    .dialog-header h2 {
      margin: 0;
      font-size: 18px;
    }
    .close-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
    }
    .dialog-content {
      min-height: 100px;
    }
  `]
})
export class CreateCounterpartyDialogComponent {
  name: string = '';

  constructor(public dialogRef: MdDialogRef<CreateCounterpartyDialogComponent>) {
  }

  selectType(isOrganisation: boolean) {
    this.dialogRef.close({ isOrganisation: isOrganisation, name: this.name });
  }

  cancel() {
    this.dialogRef.close(null);
  }
}




// WEBPACK FOOTER //
// ./src/app/admin/import/review/create-counterparty-dialog.component.ts